import { combineReducers } from 'redux';

import * as users from './users';
import * as bsResponsiblePersons from './bs-responsible-persons';
import * as stationMonitoring from './station-monitoring';

export interface State {
  users: users.State;
  bsResponsiblePersons: bsResponsiblePersons.State;
  stationMonitoring: stationMonitoring.State;
}

export const reducer = combineReducers<State>({
  users: users.reducer,
  bsResponsiblePersons: bsResponsiblePersons.reducer,
  stationMonitoring: stationMonitoring.reducer
});
